module.exports = __webpack_public_path__ + "1608cc68ed95bdab3e2373c3c69edbc0.svg";